import * as React from 'react';

const SvgAdd = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_31032_5787)">
      <path
        d="M28 0H8C3.58172 0 0 3.58172 0 8V28C0 32.4183 3.58172 36 8 36H28C32.4183 36 36 32.4183 36 28V8C36 3.58172 32.4183 0 28 0Z"
        fill="url(#paint0_linear_31032_5787)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.75 11C19.75 10.0335 18.9665 9.25 18 9.25C17.0335 9.25 16.25 10.0335 16.25 11V17.25H10C9.0335 17.25 8.25 18.0335 8.25 19C8.25 19.9665 9.0335 20.75 10 20.75H16.25V27C16.25 27.9665 17.0335 28.75 18 28.75C18.9665 28.75 19.75 27.9665 19.75 27V20.75H26C26.9665 20.75 27.75 19.9665 27.75 19C27.75 18.0335 26.9665 17.25 26 17.25H19.75V11Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_31032_5787"
        x1={6}
        y1={-7.20223e-8}
        x2={36}
        y2={29}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#386EFA" />
        <stop offset={0.0001} stopColor="#0371D7" stopOpacity={0.8} />
        <stop offset={0.0002} stopColor="#247FEA" />
        <stop offset={1} stopColor="#003DBC" />
      </linearGradient>
      <clipPath id="clip0_31032_5787">
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgAdd;
